import { Injectable } from "@angular/core";
import { StorageMap } from "@ngx-pwa/local-storage";
import { map } from "rxjs/operators";

export enum ThemeTypes {
  DarkTheme = "DarkTheme",
  LigthTheme = "LigthTheme",
}
export interface ThemeModelType {
  theme: ThemeTypes;
}
@Injectable({
  providedIn: "root",
})
export class ThemeService {
  constructor(private storage: StorageMap) {}

  private normalizeTheme(
    value: ThemeModelType | null | undefined,
  ): ThemeModelType {
    if (
      value?.theme === ThemeTypes.DarkTheme ||
      value?.theme === ThemeTypes.LigthTheme
    ) {
      return value;
    }

    return { theme: ThemeTypes.LigthTheme };
  }

  setTheme(key: string, value: ThemeModelType) {
    return this.storage.set(key, value);
  }

  getTheme(key: string) {
    return this.storage
      .get(key)
      .pipe(map((value: ThemeModelType | null) => this.normalizeTheme(value)));
  }

  removeTheme(key: string) {
    return this.storage.delete(key);
  }

  watchTheme(key: string) {
    return this.storage
      .watch(key)
      .pipe(map((value: ThemeModelType | null) => this.normalizeTheme(value)));
  }

  clear() {
    return this.storage.clear();
  }
}
